import { render, staticRenderFns } from "./TourCompletionCard.vue?vue&type=template&id=824c631e&scoped=true"
import script from "./TourCompletionCard.vue?vue&type=script&lang=js"
export * from "./TourCompletionCard.vue?vue&type=script&lang=js"
import style0 from "./TourCompletionCard.vue?vue&type=style&index=0&id=824c631e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824c631e",
  null
  
)

export default component.exports